import { lazy } from 'react';

const TermsAndConditionsPage = lazy(() => import('../pages/TermsAndConditions.page'));

const TermsAndConditionsRoutes = [
    {
        path: '/terms-and-conditions',
        element: <TermsAndConditionsPage />,
        layout: 'default',
        isAuthReq: false,
    },
];

export { TermsAndConditionsRoutes };

